import {
	Component,
	Input
}                          from '@angular/core';
import { BaseComponent }   from '@core/bases/base-component/base.component';
import { IEntityMessages } from '@core/interfaces/entity.interface';

@Component( {
	selector: 'app-entity-messages[messages]',
	templateUrl: './entity-messages.component.html',
	styleUrls: [ './entity-messages.component.scss' ]
} )
export class EntityMessagesComponent extends BaseComponent {

	@Input() defaultSpare = '';
	@Input() messages: IEntityMessages;

	constructor() {
		super();
	}
}
